import { z } from 'zod'

import { isCalendarMonth } from '@/pages/analyzer-insights/format-month'
import { rejectedValue } from '@/pages/analyzer-insights/search-rejection'

const validMonth = z.coerce.number().int().min(200001).max(209912).refine(isCalendarMonth)

export const analyzerInsightsRoomsSearchSchema = z.object({
  month: z.union([validMonth, rejectedValue]).optional().catch(undefined),
})

export type AnalyzerInsightsRoomsSearch = z.infer<typeof analyzerInsightsRoomsSearchSchema>
